import * as React from "react";
import { Workflow } from "./Workflow/Workflow";
import {
    getDashboardCoachmarkerConfig,
    DashboardTab,
    notificationsCoachmarkerConfig,
    DashboardTabArray,
} from "../Resource/Content";
import { Tab } from "../../../../Shared/Tab/Tab";
import { Permission } from "../../../../Shared/Permission/Permission";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { useState } from "react";
import CoachMarker from "../../../../Shared/CoachMarkers/CoachMarker";
import { CoachMarkerContext } from "../../../../Shared/CoachMarkers/CoachMarkerContext";
import { User } from "../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../Stroes/Variable";
import { Action } from "../../../Actions/Action";
import { CompanySummary } from "../../../../../Wrap/Models/Models/Company/CompanySummary";
import WorkflowDashboardSearch from "../../BusinessManagement/Component/Search/WorkflowDashboardSearch";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { WorkflowFilterSummaryTiles } from "./Workflow/WorkflowFilterSummaryTiles";
import { NotificationFilterSummaryTiles } from "./Notification/NotificationFilterSummaryTiles";
import { NotificationAction } from "../Action/NotificationAction";
import { Notification } from "./Notification/Notification";
import { NotificationFilterStore } from "../Store/Variable";
import { DashboardAction } from "../Action/DashboardAction";
import { ClientDashboardFiltersModel } from "../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";

interface ISecuredDashboardProps {
    onClick: (method: string, parameters?: any) => void;
}

interface ISecuredDashboardState {
    tabIndex: DashboardTab;
    content: JSX.Element;
}

export const SecuredDashboard = (props: ISecuredDashboardProps) => {
    const [state, setState] = useState<ISecuredDashboardState>({
        tabIndex: getTabIndex(),
        content: null,
    });

    const [existUnReadNotifications, updateExistUnReadNotifications] = useState(false);

    const [user, setUser] = useState<User>();
    React.useEffect(() => {
        UserStore.onChange(this, () => setUser(UserStore.getUserInfo()));
        checkUnReadNotifications();
        const maybeUser = UserStore.getUserInfo();

        if (maybeUser) {
            setUser(maybeUser);
        } else {
            Action.getUser();
        }

        return () => UserStore.removeChangeListener(this);
    }, []);

    const { tabIndex, content } = state;

    const { setPageConfig, reset } = React.useContext(CoachMarkerContext);
    //
    React.useEffect(() => {
        getContent(tabIndex);
        switch (tabIndex) {
            case DashboardTab.Notification:
                //reset();
                // setPageConfig(notificationsCoachmarkerConfig);
                break;
            case DashboardTab.Workflow:
                //reset();
                //setPageConfig(getDashboardCoachmarkerConfig(false));
                break;
            default:
                break;
        }
        return () => {
            setPageConfig(null);
        };
    }, [tabIndex]);

    const [filterState, setFilterState] = React.useState<{
        adviser: number;
        firm: CompanySummary;
    }>({
        adviser: null,
        firm: null,
    });
    React.useEffect(() => {
        if (filterState.firm != null) {
            getContent(DashboardTab.Workflow);
        }
    }, [filterState]);

    return (
        <div role="main" id="main">
            <h1 className="sr-only">Dashboard</h1>
            <h2 className="sr-only">Overview</h2>
            {((tabIndex == DashboardTab.Workflow && filterState?.firm) || tabIndex == DashboardTab.Notification) && (
                <Permission userClaim={UserClaim.AdviserPortalWorkFlowCanView}>
                    {tabIndex == DashboardTab.Workflow ? (
                        <WorkflowFilterSummaryTiles />
                    ) : (
                        <NotificationFilterSummaryTiles />
                    )}
                </Permission>
            )}
            <div>
                <CoachMarker coachMarkerKey="workflow-notifications-tab" />
                <Tab
                    tabs={DashboardTabArray}
                    existUnReadNotifications={existUnReadNotifications}
                    curTabIndex={tabIndex}
                    onClick={(tab) => getContent(tab)}
                    cssWrapper="mb-20 ad d1"
                    permission={pagePermission()}
                />
            </div>
            {content}
        </div>
    );

    function getTabIndex(): DashboardTab {
        const i = window.location.pathname.lastIndexOf("/");
        const path = window.location.pathname.substr(i + 1);
        if (CommonHelper.isNullOrEmpty(path) || path.toLowerCase() == "dashboard") {
            return DashboardTab.Workflow;
        }
        const tabs = [DashboardTab.Workflow, DashboardTab.Notification];
        let tabIndex: DashboardTab = null;
        tabs.forEach((element: string) => {
            if (element.toLowerCase() === path.toLowerCase()) {
                tabIndex = element as DashboardTab;
            }
        });
        if (path.toLowerCase() === "configure-notification") {
            tabIndex = DashboardTab.Notification;
        }
        return tabIndex;
    }

    function getContent(key: DashboardTab) {
        let _content = null;

        switch (key) {
            case DashboardTab.Workflow:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalWorkFlowCanView}>
                        {filterState.firm == null ? (
                            <WorkflowDashboardSearch
                                onSearch={(firm, adviser) => {
                                    DashboardAction.updateFilterList(firm?.CompanyCode, adviser, () => {
                                        setFilterState({ firm: firm, adviser: adviser });
                                    });
                                }}
                            />
                        ) : (
                            <Workflow
                                selectedHeadAccounts={null}
                                selectedSubAccounts={null}
                                customerId={null}
                                isActivity={false}
                                selectedCompanyCode={filterState.firm?.CompanyCode}
                                selectedAdviserId={filterState.adviser}
                            />
                        )}
                    </Permission>
                );
                break;
            case DashboardTab.Notification:
                _content = (
                    <Permission userClaim={UserClaim.AdviserPortalNotificationCanView}>
                        <Notification NotificationUpdate={checkUnReadNotifications} />
                    </Permission>
                );
                break;
        }
        setState({ content: _content, tabIndex: key });
    }

    function checkUnReadNotifications() {
        const filter = NotificationFilterStore.getDefaultFilter();

        NotificationAction.getNotificationTable(
            NotificationFilterStore.convertDashboardFilterToQuery(filter, 1),
            (d) => {
                if (d?.Results?.length) {
                    updateExistUnReadNotifications(d?.Results?.length > 0);
                } else {
                    updateExistUnReadNotifications(false);
                }
            }
        );
    }

    function pagePermission() {
        const permission = new Map<DashboardTab, UserClaim>();
        permission.set(DashboardTab.Notification, UserClaim.AdviserPortalNotificationCanView);
        permission.set(DashboardTab.Workflow, UserClaim.AdviserPortalWorkFlowCanView);
        return permission;
    }
};
